import React, { Component } from "react";
import { observer } from "mobx-react";
import "./index.css";
@observer
class AnserList extends Component {
  //点击查看问题详情
  questionDetail(data) {
    this.props.questionDetail(data);
  }
  showText(data) {
    let str = "";
    let replyMany = data.replyMany;
    if (!data.answer) {
      str = "回答";
    } else if (replyMany.length === 0) {
      str = "更新";
    } else if (replyMany[replyMany.length - 1].type === 1) {
      str = "回答";
    } else if (replyMany[replyMany.length - 1].type === 2) {
      str = "更新";
    }
    return str
  }

  render() {
    return (
      <div className="AnswerList">
        {this.props.UnAnsweredList&&this.props.UnAnsweredList.length !== 0 ? (
          this.props.UnAnsweredList &&
          this.props.UnAnsweredList.map((i, index) => (
            <div
              className="AnswerItem"
              onClick={() => {
                this.questionDetail(i);
              }}
              key={"AnswerItem" + index}
            >
              <div>
                <span>{i.storeQuestionEntity.id}</span>
                <span>{this.showText(i.storeQuestionEntity)}</span>
              </div>
              <p>{i.storeQuestionEntity.question}</p>
            </div>
          ))
        ) : (
          <div className="noAnswers">暂无需要回答的问题</div>
        )}
      </div>
    );
  }
}
export default AnserList;
